export default __webpack_public_path__ + "/assets/progetto_9.jpg";